import {
    Box,
    Flex,
    Heading,
    Spinner,
    Tab,
    TabList,
    Tabs,
    Text,
    useColorMode
} from '@chakra-ui/react';

import Dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import Chart from '../../components/chart';
import Layout from '../../components/layout';
import WidgetRow from '../../components/widget-row';
import WidgetRowMultipleBet from '../../components/widget-row-multiple-bet';
import useGetBetSplitData from '../../hooks/useGetBetSplitData';
import { useSession } from '../../hooks/useSession';

export default function BetSplit() {
    const session = useSession();
    const [page, setPage] = useState(1);
    const { colorMode, toggleColorMode } = useColorMode();
    const [currentFilterIndx, setCurrentFilterIndx] = useState(0);
    const dateFilters = [
        {
            label: 'Active',
            value: null,
        },
        {
            label: '1D',
            value: Dayjs().subtract(3, 'months').format('YYYY-MM-DD'),
        },
        {
            label: '1M',
            value: Dayjs().subtract(6, 'months').format('YYYY-MM-DD'),
        },
        {
            label: '1Y',
            value: Dayjs().subtract(12, 'months').format('YYYY-MM-DD'),
        },
        {
            label: 'All',
            value: null,
        },
    ];
    const currentFilter = dateFilters.find(
        (filter, index) => currentFilterIndx === index
    );

    const { loading, result, error } = useGetBetSplitData(
        session?.token!,
        session?.internalId!,
        page,
        currentFilter?.value!
    );

    useEffect(() => {
        setPage(1);
    }, [currentFilterIndx]);

    useEffect(() => {
        if (session?.uiMode && session?.uiMode != 'system'  && session?.uiMode != colorMode) toggleColorMode()
    }, []);

    useEffect(() => {
        const onScroll = () => {
            let scrollHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.body.clientHeight,
                document.documentElement.clientHeight
            );

            if (
                window.scrollY + document.documentElement.clientHeight + 100 >
                    scrollHeight &&
                !loading
            ) {
                setPage((page) => page + 1);
            }

            //setPage((page) => page + 1);
        };
        document.addEventListener('scroll', onScroll);

        return () => document.removeEventListener('scroll', onScroll);
    }, [loading]);

    const betSplit = result;

    return (
        <Layout size="large" colorMode = {colorMode}>
            <Flex direction="column" w="full" gap="40px">
                <Flex
                    w="full"
                    align={{ base: 'flex-start', md: 'center' }}
                    justify="space-between"
                    flexDir={{ base: 'column', md: 'row' }}
                    gap={{ base: '40px', md: '20px' }}
                >
                    <Flex
                        direction="column"
                        align={{ base: 'flex-start', md: 'center' }}
                        w="full"
                        maxW={{ base: 'full', md: '180px' }}
                    >
                        <Heading size="lg" m={{ base: '0', md: '0 auto' }}>
                            My Bets
                        </Heading>
                        <Text size="sm" lineHeight="24px">
                            View, share, and analyze bets
                        </Text>
                    </Flex>
                    <Box w="full" maxW="450px">
                        <Tabs
                            isFitted={true}
                            index={currentFilterIndx}
                            onChange={setCurrentFilterIndx}
                        >
                            <TabList>
                                {dateFilters.map((filter, indx) => (
                                    <Tab key={indx}>{filter.label}</Tab>
                                ))}
                            </TabList>
                        </Tabs>
                    </Box>
                </Flex>

                <Flex
                    gap="10px"
                    w={{ base: 'calc(100% + 32px)', md: 'full' }}
                    overflowX={{ base: 'auto', md: 'hidden' }}
                    px={{ base: '16px', md: '0' }}
                    m={{ base: '0 -16px', md: '0' }}
                >
                    <Box
                        w="full"
                        minW={{ base: '150px', md: 'unset' }}
                        maxW={{ base: '150px', md: 'unset' }}
                    >
                        <Chart />
                    </Box>
                </Flex>

                <Flex direction="column" gap="60px" mt="10px" mb="30px">
                    {betSplit &&
                        betSplit.objects.map((object, index) =>
                            object.bets.length > 1 ? (
                                <WidgetRowMultipleBet
                                    key={`${object.id}-${index}`}
                                    betObject={object}
                                />
                            ) : (
                                <WidgetRow
                                    key={`${object.id}-${index}`}
                                    betObject={object}
                                />
                            )
                        )}
                    {loading && (
                        <Flex
                            w="full"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Spinner />
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </Layout>
    );
}
